<template>
	<div class="header" :class="{[`bg-${type}`]: type}">
		<div class="container-fluid">
			<div class="row" v-if="!user.setupComplete">
				<div class="col-md-12" v-if="!user.setupOrganization">
					<div class="card">
						<div class="card-body">
							<h3 class="card-title">Getting Started</h3>
							<p class="card-text">To get you onboarded we'll need you to head over to your profile page and fill out your organization info. Once that is completed we will internally review your account and assign you a partner id.</p>
						<div class="alert alert-secondary" role="alert" v-if="$route.name === 'profile'">
							<strong>Almost There!</strong> Fill out your organization info below...
						</div>
						<router-link to="/profile" class="btn btn-primary" v-else>Setup My Organization</router-link>
						</div>
					</div>
				</div>
				<div class="col-md-12" v-else-if="!user.setupApiKey">
					<div class="card">
						<div class="card-body">
							<h3 class="card-title">Create an API Key</h3>
							<p class="card-text">To access our API you'll need to create an API Key at the bottom of your profile page.</p>
							<div class="alert alert-secondary" role="alert" v-if="$route.name === 'profile'">
								<strong>Almost There!</strong> Create your API key at the bottom of this page...
							</div>
							<router-link to="/profile" class="btn btn-primary" v-else>Create My Key</router-link>
						</div>
					</div>
				</div>
				<div class="col-md-12" v-else-if="((!user.setupComplete && $route.name === 'docs') || !user.readDocs)">
					<div class="card">
						<div class="card-body">
							<h3 class="card-title">Get your feet wet :D</h3>
							<p class="card-text">You can use our interactive API Docs to test our endpoints. We've even preauthorized your api key to make things easier :D</p>
							<div class="alert alert-secondary" role="alert" v-if="$route.name === 'docs'">
								<strong>You made it!</strong> Try out the api below and feel free to reach out if you have any questions :D
								<span class="close" style="margin-top: 20px; opacity: 1;"><button type="button" class="btn btn-success" @click.prevent="endSetup">End Setup</button></span>
							</div>
							<a class="btn btn-success text-white" @click.prevent="markDocsRead" v-else>Check out the Docs</a>
						</div>
					</div>
				</div>
			</div>
			<div class="header-body">
				<slot></slot>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex';
	export default {
		name: 'base-header',
		props: {
			type: {
				type: String,
				default: 'primary',
				description: 'Header background type',
				closeNow: false
			}
		},
		data () {
			return {
				closeNow: false
			};
		},
		computed: {
			...mapGetters({
				user: 'auth/user',
				isAdmin: 'auth/isAdmin'
			})
		},
		methods: {
			async markDocsRead () {
				this.user.readDocs = true;
				await this.user.save();
				this.$router.push('/docs');
			},
			async endSetup () {
				this.user.setupComplete = true;
				this.user.save();
				this.closeNow = true;
			}
		}
	}
</script>
<style>
</style>
